// @flow
import React, {
  useState,
  useRef,
  useEffect,
} from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { getCountryCallingCode } from "libphonenumber-js";
import {
  Input,
  SelectBox,
} from '../../../design';
import {
  SpText,
  SpWidgetButton,
  SpTermsAndServices,
  SpError,
} from '../../../widgetDesign';
import { COUNTRY_PHONE_CODE } from "../../../appconstants";
import { imgWith } from "../../../utils/reseponsive";
import swirepaylogo from '../../../assets/imgs/swirepay-logo.svg';
import step1 from '../../../assets/imgs/step1.png';
import step2 from '../../../assets/imgs/step2.png';
import arrow from '../../../assets/imgs/arrow.png';
import navRight from '../../../assets/imgs/right.png';

type Props = {
  payment: Object,
  employmentInfo: Function,
  getPreviousTab: Function,
  whiteLabel: Boolean,
};

const EmploymentInfo = (props: Props) => {
  const {
    payment,
    employmentInfo,
    getPreviousTab,
    whiteLabel,
  } = props;

  const [, forceUpdate] = useState();
  const employInfo = payment.paymentWidget && payment.paymentWidget.employDetails ? payment.paymentWidget.employDetails : null;
  const [unEmployed, setUnEmployed] = useState(null);
  const [employed, setEmployed] = useState(null);
  const [firstName, setFirstName] = useState(employInfo ? employInfo.firstName : '');
  const [lastName, setLastName] = useState(employInfo ? employInfo.lastName : '');
  const [email, setEmail] = useState(employInfo ? employInfo.email : '');
  const [countryCode, setCountryCode] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(employInfo ? employInfo.phoneNumber : null);
  const [comapnyDonation, setComapanyDonation] = useState(false);
  const [employmentStatus, setEmploymentStatus] = useState(employInfo ? employInfo.employmentStatus : null);
  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      firstname: {
        message: 'First Name should be min 4 character',
        rule: val => val.length >= 4,
      },
      lastname: {
        message: 'Last Name should be min 4 character',
        rule: val => val.length >= 4,
      },
      checkLowerCase: {
        message: 'Email address must not contain uppercase letters.',
        rule: (val) => val === val.toLowerCase(),
      },
    },
  }));

  useEffect(() => {
    const isEmployed = employInfo ? employInfo.employmentStatus : null;
    const isCompanyDonation = employInfo ? employInfo.comapnyDonation : null;
    const countryCallingCode = payment && payment.account ? payment.account.country.alpha2 : null;
    if (isEmployed) {
      setEmployed(true);
    } else if (isEmployed === false) {
      setUnEmployed(true);
    }
    if (isCompanyDonation) {
      setComapanyDonation(true);
    }
    if (countryCallingCode) {
      setCountryCode(`+${getCountryCallingCode(countryCallingCode)}`);
    }
  }, [payment]);

  const onPhoneNumberChange = (e) => {
    const val = e.currentTarget.value;
    setPhoneNumber(val.replace(/[^0-9+]/g, ''));
  };

  const updateCountryCode = (e) => {
    setCountryCode(e.currentTarget.value);
  };

  const previous = () => {
    getPreviousTab({
      firstName,
      lastName,
      email,
      phoneNumber,
      comapnyDonation,
      employmentStatus,
    });
  };

  const employmentDetails = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const phone = `${countryCode}${phoneNumber}`
    employmentInfo({
      firstName,
      lastName,
      email,
      phone,
      comapnyDonation,
      employmentStatus,
    });
  };

  return (
    <>
      <div style={{ padding: '0px 45px', verticalAlign: 'middle' }}>
        <img
          src={navRight}
          alt="step"
          style={{
            marginRight: "55px",
            cursor: "pointer",
            transform: "rotate(180deg)",
          }}
          onClick={previous}
        />
        <SpText fontSize="17px">
          Information
        </SpText>
        <img
          src={navRight}
          alt="step"
          style={{ marginLeft: "50px", cursor: "pointer" }}
          onClick={employmentDetails}
        />
      </div>
      <div style={{ textAlign: 'center' }}>
        <img src={step2} alt="step" className="mr-2" />
        <img src={step1} alt="step" className="mr-2" />
        <img src={step2} alt="step" />
      </div>
      <div className="mt-2" style={{ padding: '0px 45px' }}>
        <div style={{ textAlign: 'left' }}>
          <label htmlFor=""><SpText fontSize="14px">First Name</SpText></label>
        </div>
        <Input
          style={{ width: "300px" }}
          onChange={(e) => setFirstName(e.currentTarget.value.trim())}
          value={firstName}
        />
        <SpError>
          {simpleValidator.current.message('first name', firstName, 'required|firstname')}
        </SpError>
      </div>
      <div className="mt-2" style={{ padding: '0px 45px' }}>
        <div style={{ textAlign: 'left' }}>
          <label htmlFor=""><SpText fontSize="14px">Last Name</SpText></label>
        </div>
        <Input
          style={{ width: "300px" }}
          onChange={(e) => setLastName(e.currentTarget.value.trim())}
          minlength="4"
          value={lastName}
        />
        <SpError>
          {simpleValidator.current.message('last name', lastName, 'required|lastname')}
        </SpError>
      </div>
      <div className="mt-2" style={{ padding: '0px 45px' }}>
        <div style={{ textAlign: 'left' }}>
          <label htmlFor=""><SpText fontSize="14px">Email</SpText></label>
        </div>
        <Input
          style={{ width: "300px" }}
          onChange={(e) => setEmail(e.currentTarget.value.trim())}
          value={email}
        />
        <SpError>
          {simpleValidator.current.message('email', email, 'required|email|checkLowerCase')}
        </SpError>
      </div>
      <div className="mt-2" style={{ padding: '0px 45px' }}>
        <div style={{ textAlign: 'left' }}>
          <label htmlFor=""><SpText fontSize="14px">Phone</SpText></label>
        </div>

        <div className="d-flex" verticalAlign="middle">
          <SelectBox
            className="col-4 px-0"
            value={countryCode}
            style={{ color: '#6A6A6A' }}
            onChange={updateCountryCode}
            showSearch
          >
            {
              COUNTRY_PHONE_CODE
                .map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))
            }
          </SelectBox>
          <Input
            style={{ width: "200px" }}
            onChange={onPhoneNumberChange}
            maxLength={10}
            value={phoneNumber}
          />
        </div>
        <SpError>
          {simpleValidator.current.message('phone number', phoneNumber, 'required|phone')}
        </SpError>
      </div>
      <div className="mt-1" style={{ padding: '0px 45px' }}>
        {
          payment.paymentWidget.companyDonation && (
            <div style={{ textAlign: 'left' }}>
              <Input
                type="checkbox"
                className="mr-2"
                checked={comapnyDonation}
                style={{ width: "30px", height: "18px", verticalAlign: "middle" }}
                onChange={({ target: { checked } }) => {
                  setComapanyDonation(checked);
                }}
              />
              <SpText fontSize="14px">This payment is on behalf of a company</SpText>
            </div>
          )
        }
      </div>
      {
        payment.paymentWidget.needEmploymentStatus && (
          <>
            <div className="mt-2" style={{ padding: '0px 46px' }}>
              <div style={{ textAlign: 'left' }}>
                <SpText fontSize="14px">Are you currently employed?</SpText>
              </div>
            </div>
            <div className="mt-2" style={{ padding: '0px 45px' }}>
              <div style={{ textAlign: 'left' }}>
                <Input
                  type="radio"
                  style={{ width: "30px", height: "15px", verticalAlign: "middle" }}
                  checked={employed}
                  onChange={({ target: { checked } }) => {
                    setEmployed(checked);
                    setUnEmployed(!checked);
                    setEmploymentStatus(checked);
                  }}
                />
                <SpText fontSize="14px">Yes</SpText>
                <Input
                  type="radio"
                  style={{ width: "30px", height: "15px", verticalAlign: "middle" }}
                  checked={unEmployed}
                  onChange={({ target: { checked } }) => {
                    setEmployed(!checked);
                    setUnEmployed(checked);
                    setEmploymentStatus(!checked);
                  }}
                />
                <SpText fontSize="14px">No</SpText>
              </div>
              <SpError>
                {simpleValidator.current.message('employment status', employmentStatus, 'required')}
              </SpError>
            </div>
          </>
        )
      }
      <div className="mt-4" style={{ padding: '0px 45px' }}>
        <SpWidgetButton
          backgroundColor={payment.paymentWidget.primaryColor}
          onClick={employmentDetails}
        >
          Next <img style={{ verticalAlign: "middle" }} src={arrow} alt="arrow" />
        </SpWidgetButton>
      </div>
      {
        (whiteLabel === false) ? (
          <div className="mt-3 align-items-center" style={{ padding: '0px 45px' }}>
            <SpText
              fontSize="10px"
              color="rgba(0, 0, 0, 0.7)"
              className="mr-2"
            >
              Powered by
            </SpText>
            <span className="mt-3">
              <img style={{ verticalAlign: "middle", paddingBottom: "10px" }} width={imgWith(12)} src={swirepaylogo} alt="" />
            </span>
          </div>
        ) : ''
      }
      <SpTermsAndServices style={{ padding: '20px 45px' }}>
        <SpText fontSize="11px" color="rgba(0, 0, 0, 0.7)">
          By paying with this form you agree to our
        </SpText><br />
        <SpText fontSize="13px" color="#3DA8FE">
          Terms of Services
        </SpText>
      </SpTermsAndServices>
    </>
  );
};

// $FlowFixMe
export default EmploymentInfo;
